// Ampel-Logik für den V-Check-Wizard (gespiegelt aus backend `_compute_progress`).

export const showIfMatches = (cond, data) => {
  if (!cond) return true;
  const v = data?.[cond.field];
  if ("equals" in cond) return v === cond.equals;
  if ("gte" in cond) {
    const n = Number(v);
    return v !== null && v !== undefined && v !== "" && !Number.isNaN(n) && n >= cond.gte;
  }
  return true;
};

export const visibleFields = (section, data) =>
  (section.fields || []).filter((f) => showIfMatches(f.show_if, data));

export const isEmpty = (v) =>
  v === undefined || v === null || v === "" || (Array.isArray(v) && v.length === 0);

export const effMinPhotos = (f, data) => {
  const d = f.min_photos || 1;
  const r = f.min_photos_if;
  return r && showIfMatches(r, data) ? (r.min_photos ?? d) : d;
};

export const photoCount = (f, doc) =>
  (doc?.photos?.[f.key] || []).length + (f.floorplan ? (doc?.floorplan_sketches || []).length : 0);

// "done" | "na" | "open" | "optional" | "info"
export function itemStatus(f, doc) {
  if (doc?.na?.[f.key]) return "na";
  if (f.readonly) return "info";
  if (f.type === "signature") return doc?.customer_signature ? "done" : "optional";
  if (f.type === "photo_block") {
    if (photoCount(f, doc) >= effMinPhotos(f, doc?.data || {})) return "done";
    return f.required ? "open" : "optional";
  }
  if (!isEmpty(doc?.data?.[f.key])) return "done";
  return f.required ? "open" : "optional";
}

const countable = (f) => f.required && f.type !== "signature" && !f.readonly;

export function sectionStats(section, doc) {
  const req = visibleFields(section, doc?.data || {}).filter(countable);
  const openFields = req.filter((f) => itemStatus(f, doc) === "open");
  const done = req.length - openFields.length;
  return {
    total: req.length,
    done,
    open: openFields.length,
    openFields,
    pct: req.length ? Math.round((done / req.length) * 100) : 100,
  };
}

export function overallStats(sections, doc) {
  let total = 0;
  let done = 0;
  for (const s of sections) {
    const st = sectionStats(s, doc);
    total += st.total;
    done += st.done;
  }
  return { total, done, open: total - done, pct: total ? Math.round((done / total) * 100) : 100 };
}

// Ampel-Farben pro Status
export const STATUS_STYLE = {
  done: { bar: "bg-emerald-500", text: "text-emerald-300", border: "border-emerald-500/40" },
  na: { bar: "bg-emerald-500", text: "text-emerald-300", border: "border-emerald-500/40" },
  open: { bar: "bg-red-500", text: "text-red-300", border: "border-red-500/50" },
  optional: { bar: "bg-zinc-600", text: "text-zinc-400", border: "border-zinc-800" },
  info: { bar: "bg-zinc-700", text: "text-zinc-400", border: "border-zinc-800" },
};
